import axios from "axios";
import appConfig from "@src/app.config";
import authService from "@services/auth";
import store from "@store";
import router from "@router";
import NProgress from "nprogress";

const api = axios.create({
  baseURL: appConfig.apiUrl
});

api.interceptors.request.use(async config => {
  NProgress.start();

  const token = authService.getToken();
  if (token) {
    config.headers.common["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  function(response) {
    NProgress.done();

    if (!response.ok) {
      // unauthorized
      if (response.data["status"].toLowerCase() === "error") {
        store.dispatch("alert/error", response.data["message"], { root: true });
      } else if (response.status === 401) {
        router.push("/Login");
      } else if (response.status === 403) {
        router.push("/403");
      }
    }
    return response;
  },
  function(error) {
    NProgress.done();

    if (!error.response) {
      store.dispatch(
        "alert/error",
        "Ocorreu um erro de comunicação com os nossos serviços. Por favor, tente novamente em alguns instantes.",
        { root: true }
      );
    }

    if (401 === error.response.status) {
      authService.logout();
      router.push("/Login");
    } else if (403 === error.response.status) {
      router.push("/403");
    } else if (500 === error.response.status) {
      store.dispatch(
        "alert/error",
        error.data && error.data.message
          ? error.data.message
          : "Ocorreu um erro na sua requisição. Tente novamente mais tarde ou entre em contato com o suporte.",
        { root: true }
      );
    }
  }
);

export default api;
